import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // SpringCleaningCarrefour2022 campaign
        "pageName": "SpringCleaningCarrefour2022",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "margin": '2% 0 0 0',
                    "padding": '0'
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/SpringCleaningCarrefour2022/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/SpringCleaningCarrefour2022/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#3A86CA",
                  "buttonClass": "btn-mandarin",
                  "nextPage": "SpringCleaningCarrefour2022/InscrieBonul",
                  "campaign": "SpringCleaningCarrefour2022",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Cumpara produse Ajax si/sau Axion  de min. 15 Lei de la Carrefour",
                      "image": "select"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Incarca bonul fiscal",
                      "image": "receipt"
                    },
                    {
                      "title": "Pasul 3",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    },
                    {
                      "title": "Pasul 4",
                      "text": "Castiga premii!",
                      "image": "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        "pageName": "SpringCleaningCarrefour2022/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 0,
                  "colorSchema": "#3A86CA",
                  "stepShadow": "rgba(179, 208, 234, 1)",
                  "startGradient": "linear-gradient(258.78deg, #629FD5 19.8%, #3A86CA 81.66%)",
                  "endGradient": "linear-gradient(258.78deg, #629FD5 19.8%, #3A86CA 81.66%)",
                  "completedGradient": "linear-gradient(258.78deg, #629FD5 19.8%, #3A86CA 81.66%), #ffffff",
                  "steps": [
                    {
                      "title": "Incarca bonul fiscal/factura",
                      "page": "SpringCleaningCarrefour2022/InscrieBonul"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "SpringCleaningCarrefour2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa incarci dovada achizitionarii produselor Ajax si/sau Axion",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#0C181D"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un pdf al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "26px;",
                    "color": "#0C181D"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#3A86CA",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#0C181D",
                        "borderColor": "#C0DDE2",
                        "buttonClass": "btn-blue-receipt-upload",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "SpringCleaningCarrefour2022/Inregistreaza"
                        },
                        "campaignId": "spring-carrefour",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#fff",
                        "eraseSize": 12,
                        "cropColor": "#3A86CA",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#3A86CA",
                        "backgroundColorBtn": "black"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left",
                                "background": "#3A86CA"
                              },
                              "color": "#3A86CA",
                              "textColor": "#1B3641",
                              "descriptionText": "Te rugam sa faci o poza a bonului fiscal/facturii. Urmatoarele informatii trebuie sa fie vizibile:",
                              "receiptImage": "receipt14",
                              "steps": [
                                {
                                  "text": "Nume Retailer/ Magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele care intra in promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "SpringCleaningCarrefour2022"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "addClass": "btn-mandarin",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        "pageName": "SpringCleaningCarrefour2022/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
                {
                    "fieldType": "step-counter",
                    "fieldId": "tj4j49",
                    "properties": {
                      "activeIndex": 1,
                      "colorSchema": "#3A86CA",
                      "stepShadow": "rgba(179, 208, 234, 1)",
                      "startGradient": "linear-gradient(258.78deg, #629FD5 19.8%, #3A86CA 81.66%)",
                      "endGradient": "linear-gradient(258.78deg, #629FD5 19.8%, #3A86CA 81.66%)",
                      "completedGradient": "linear-gradient(258.78deg, #629FD5 19.8%, #3A86CA 81.66%), #ffffff",
                      "steps": [
                        {
                          "title": "Incarca bonul fiscal/factura",
                          "page": "SpringCleaningCarrefour2022/InscrieBonul"
                        },
                        {
                          "title": "Inregistreaza-te",
                          "page": "SpringCleaningCarrefour2022/Inregistreaza"
                        }
                      ]
                    }
                  },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1>Formular de inscriere</h1>"
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#F8FBFC"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "SpringCleaningCarrefour2022/Multumim"
                  },
                  "endpoint": "/register",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "35px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#0C181D !important"
                        }
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "rgba(5, 14, 35, 1)",
                          "--border": "1px solid #C0DDE2",
                          "background-color":"border: #C0DDE2",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/SpringCleaningCarrefour2022Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "SpringCleaningCarrefour2022/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-mandarin",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        "pageName": "SpringCleaningCarrefour2022/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#0C181D"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#F8FBFC"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "SpringCleaningCarrefour2022/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "rgba(0, 41, 28, 1) !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#0C181D",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#0C181D",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#C0DDE2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#0C181D",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-mandarin",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        "pageName": "SpringCleaningCarrefour2022/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "SpringCleaningCarrefour2022",
                  "campaignName": "CAMPANIE SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "textColor": "#1B3641",
                  "imageStyles":{
                    'margin-bottom': '27%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        "pageName": "SpringCleaningCarrefour2022/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Bonul fiscal/factura incarcat/a anterior nu este complet/a sau este ilizibl/a.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#1B3641"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "30px;",
                    "color": "#1B3641"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#3A86CA",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#1B3641",
                        "borderColor": "#C0DDE2",
                        "buttonClass": "btn-blue-receipt-upload",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "SpringCleaningCarrefour2022/Multumim"
                        },
                        "campaignId": "spring-carrefour",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#3A86CA",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#3A86CA",
                        "backgroundColorBtn": "black",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#3A86CA",
                              "textColor": "#1B3641",
                              "descriptionText": "Te rugam sa faci o poza a bonului fiscal/facturii. Urmatoarele informatii trebuie sa fie vizibile:",
                              "receiptImage": "receipt14",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului fiscal/facturii in LEI",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr. bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bonul fiscal sau factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-mandarin",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        "pageName": "SpringCleaningCarrefour2022/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Incarca o poza a produsului</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#1B3641"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#1B3641"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#3A86CA",
                        "borderColor": "#C0DDE2",
                        "buttonClass": "btn-blue-receipt-upload",
                        "textColor": "#1B3641",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "SpringCleaningCarrefour2022/Multumim"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-mandarin",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "SpringCleaningCarrefour2022/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "SpringCleaningCarrefour2022",
                  "campaignName": "CAMPANIE SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "borderColor": "#DFEBF6",
                  "textColor": "#1B3641",
                  "referenceColor": "#2D6DA6",
                  "imageStyles":{
                    'margin-bottom': '27%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Error page
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "SpringCleaningCarrefour2022/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#1B3641",
                  "title": "Intrebari frecvente",
                  "items": [
                    { // 1
                      title: `Ce conditii trebuie sa indeplinesc pentru a participa la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”?`,
                      text: `
                      <ul>
                          <li>Varsta minima: Trebuie sa ai cel putin 18 ani.</li>
                          <li>Domiciliul: Trebuie sa ai domiciliul in Romania.</li>
                          <li>Numarul de telefon: Trebuie sa ai un numar de telefon mobil romanesc.</li>
                          <li>Adresa de e-mail: Poti participa doar cu propria adresa de e-mail.</li>
                      </ul>
                      <div style="margin-top: 10px">Nota: Numarul de telefon si adresa de e-mail pot fi combinate o singura data pentru intreaga
                      perioada a campaniei.</div>`
                    },
                    { // 2
                      title: `Cum pot participa la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”?`,
                      text: `PPoti participa doar online, prin intermediul site-ului campaniei <a href="/SpringCleaningCarrefour2022" target="_blank">promocolgatepalmolive.ro</a>. Din pacate, nu este posibila participarea prin posta. Procesul poate fi descris dupa cum urmeaza:
                      <ul style="margin-top: 10px; margin-bottom: 10px">
                          <li>Achizitioneaza produse Ajax sau Axion in valoare de cel putin 15 lei;</li>
                          <li>Fotografiaza si incarca bonul fiscal/factura;</li>
                      </ul>
                      Doar in cazul solicitarii ulterioare, trebuie sa incarci o fotografie a partii posterioare a produsului tau, respectiv produselor tale Ajax sau Axion. (Trebuie sa te asiguri ca este vizibil codul de bare al produsului tau, respectiv produselor tale.) In mod suplimentar, bonul fiscal/factura trebuie sa apara clar/a si lizibil/a pe fotografia cu produsul.
                      <ul style="margin-top: 10px;">
                          <li>Introdu adresa de e-mail, numarul de telefon si alte informatii personale;</li>
                          <li>Accepta regulamentul de participare si protectia datelor.</li>
                      </ul>
                      <div style="margin-top: 10px">Nota: Nu este posibila utilizarea unor adrese de e-mail diferite si numere de telefon mobil (conturi de utilizator) pentru aceeasi persoana.</div>`
                    },
                    { // 3
                      title: `Pe cine trebuie sa contactez daca am o intrebare privitoare la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”?`,
                      text: `Te rugam sa contactezi serviciul de relatii clienti Ajax si Axion la adresa <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>`
                    },
                    { // 4
                      title: ``,
                      text: `Produsele participante sunt urmatoarele:
                      <ul style="margin-top: 10px;">
                          <li>AJAX BOOST CHARCOAL 1L</li>
                          <li>AJAX BOOST MULTISURFACES VINEGAR&LAV 1L</li>
                          <li>AJAX FL.FIESTA FLOW.BOUQUET LW 500M SPT</li>
                          <li>AJAX FL.FIESTA FLOW.OF SPRING LQ 1L</li>
                          <li>AJAX FL.FIESTA FLOW.OF SPRING LW500M SPT</li>
                          <li>AJAX FL.FIESTA FLOW.OF SPRING LW500M SQ</li>
                          <li>AJAX FL.FIESTA HIBISCUS 1L</li>
                          <li>AJAX FL.FIESTA LAGOON FLOWERS LQ 1L</li>
                          <li>AJAX FL.FIESTA LILAC BREEZE LQ 1L</li>
                          <li>AJAX OPTIMAL FLOOR ALMOND OIL 1L</li>
                          <li>AJAX PLANT BASED WIPES 70 PCS</li>
                          <li>AJAX PURE HOME APPLE 1L</li>
                          <li>AJAX PURE HOME APPLE 500ML</li>
                          <li>AJAX PURE HOME EDDELFLOWER 500ML</li>
                          <li>AJAX PURE HOME ELDERFLOWER 1L</li>
                          <li>AJAX SC DISINF 1X12X500ML CEE</li>
                          <li>AJAX SOL GEAMURI OPTIMAL 7 CRISTAL 500ML</li>
                          <li>AJAX TRIPLE ACTION GLASS 500ML SPT</li>
                          <li>AJAX WC POWER 500ML</li>
                          <li>AJAX WIND.&SHINY SURFACES 500ML SPT</li>
                          <li>AXION ALOE 225G</li>
                          <li>AXION ALOE 400G</li>
                          <li>AXION FUSION 225G</li>
                          <li>AXION LEMON 225GR S</li>
                          <li>AXION LEMON 400GR S</li>
                          <li>AXION ULTRA DEGRESANT S 225GR BLUE</li>
                          <li>AXION ULTRA DEGRESANT S 400GR BLUE</li>
                          <li>LICHID PENTRU SUPRAFETE AJAX FLORAL FIESTA (CARRIBEAN) DUAL FRAGRANCE GARDENIA & COCONUT 1000ML</li>
                          <li>LICHID PENTRU SUPRAFETE AJAX FLORAL FIESTA (TROPICAL) DUAL FRAGRANCE WATER LILY & VANILLA 1000ML</li>
                          <li>LICHID SUPRAFETE AJAX DEZINFECTANT 1L</li>
                          <li>PRAF DE CURATAT AJAX DOUBLE BLEACH 450G</li>
                          <li>PRAF DE CURATAT AJAX FLOWER OF SPRING 450G</li>
                          <li>PRAF DE CURATAT AJAX LEMON 450G</li>
                      </ul>`
                    },
                    { // 5
                      title: `De unde pot cumpara produsele participante la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”?`,
                      text: `Poti cumpara toate produsele participante la campanie din Cora si magazinul online din Romania.`
                    },
                    { // 6
                      title: `Cand pot participa la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”?`,
                      text: `Perioada de achizitie a produselor participante este cuprinsa intre 24.03.2022 si, inclusiv, 24.04.2022.
                      Termenul-limita pentru trimiterea formularului de inregistrare online si incarcarea bonului
                      fiscal/facturii de achizitie este 24.04.2022.`
                    },
                    { // 7
                      title: `Cat de des pot participa la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”?`,
                      text: `Nu exista limita de participare. Poti participa de cate ori doresti.`
                    },
                    { // 8
                      title: 'Cand pot primi premiul?',
                      text: `Dupa tragerea la sorti – in cazul in care esti declarat/a castigator/e –, vei fi imediat contactat/a
                      pentru a furniza adresa de livrare si CNP-ul. Vei primi premiul prin curier in termen de o luna dupa
                      trimiterea informatiilor suplimentare.`
                    },
                    { // 9
                      title: `Bonul meu fiscal/factura contine mai multe produse participante decat minimul necesar. Pot doua sau mai multe persoane sa foloseasca bonul fiscal/factura pentru participarea la tragerea la sorti?`,
                      text: `In principiu, un bon fiscal/o factura poate participa o singura data la „CAMPANIA SPRING CLEANING AJAX & AXION CARREFOUR HYPER & ONLINE”. Produsele participante enumerate pe bonul fiscal/factura nu pot fi luate in considerare, iar un produs participant nu poate fi transferat altei persoane.`
                    },
                    { // 10
                      title: 'Nu am primit un e-mail de confirmare dupa terminarea procesului de inscriere. Ce trebuie sa fac?',
                      text: `Dupa ce te-ai inregistrat, vei primi un e-mail de confirmare cu un numar de referinta format din 10
                      caractere alfanumerice. Te rugam sa verifici dosarul de SPAM si JUNK. Daca nu ai primit un numar
                      de referinta format din 10 caractere alfanumerice, te rugam sa participi din nou prin intermediul
                      site-ului pentru promotii <a href="/SpringCleaningCarrefour2022" target="_blank">promocolgatepalmolive.ro./SpringCleaningCarrefour2022</a>.`
                    },
                    { // 11
                      title: 'Am introdus o adresa de e-mail gresita. Exista o modalitate de a afla daca am castigat?',
                      text: `Fiecare castigator din campanie va fi anuntat pe pagina cu castigatori: <br />
                      <a href="/SpringCleaningCarrefour2022/castigatori" target="_blank">promocolgatepalmolive.ro/SpringCleaningCarrefour2022/castigatori/</a>`
                    },
                    { // 12
                      title: 'Cand parcurg procesul de inscriere pentru participarea la tragerea la sorti, acesta se blocheaza la un moment dat. Ce trebuie sa fac?',
                      text: `Daca te incurci in timpul procesului de inscriere din motive tehnice, iti recomandam – daca este
                      posibil – sa utilizezi un alt dispozitiv. De exemplu, treci de pe telefonul mobil pe calculator. Daca
                      acest lucru nu rezolva problema, poti incerca sa folosesti un alt browser (Google Chrome, Microsoft
                      Edge, Mozilla Firefox). Daca sfaturile nu te ajuta, te rugam sa trimiti un e-mail departamentului
                      nostru de suport: <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>. Te rugam sa furnizezi o descriere precisa a
                      problemei in e-mailul tau – o captura de ecran cu pasul la care te blochezi este perfecta. Alte
                      informatii utile sunt dispozitivul tau, sistemul de operare si browserul pe care le folosesti. Echipa
                      noastra de suport se va stradui sa te ajute.`
                    },
                    { // 13
                      title: 'Cum imi pot da seama daca am reusit sa incarc bonul fiscal/factura?',
                      text: `Dupa ce incarci bonul fiscal/factura si introduci informatiile personale, inclusiv numarul tau de
                      telefon mobil, va aparea un mesaj pe ecran care confirma inscrierea participarii tale si iti afiseaza
                      numarul personal de referinta. Vei primi cu promptitudine si un e-mail de confirmare sau respingere
                      a participarii pe adresa furnizata.`
                    },
                    { // 14
                      title: 'Cat timp este disponibil departamentul de suport?',
                      text: `Echipa noastra de suport este disponibila de la inceputul campaniei timp de 6 saptamani dupa
                      expirarea datei de inregistrare. Dupa 05.06.2022, datele tale vor fi sterse, departamentul de suport
                      va fi inchis, iar intrebarile tale nu vor mai fi tratate.`
                    },
                    { // 15
                      title: 'Bonul fiscal/factura mi-a fost respins/a deoarece nu sunt lizibile toate informatiile. Ce informatii trebuie sa fie lizibile?',
                      text: `Magazinul, produsele participante Ajax sau Axion, pretul de achizitie al produselor participante,
                      valoarea totala a bonului fiscal/facturii, numarul bonului fiscal/facturii, TVA-ul, orice reduceri care
                      pot fi aplicate, precum si ora si data.`
                    },
                    { // 16
                      title: 'De ce mi-a fost respinsa participarea, desi am cumparat produsele participante?',
                      text: `De exemplu, poate fi din cauza unei erori tehnice sau a faptului ca bonul fiscal/factura nu este
                      suficient de lizibil/a sau este supraexpus/a.
                      In partea de jos a e-mailului de respingere, vei gasi un buton pentru a incarca bonul fiscal/factura
                      din nou. Da clic pe buton si vei fi redirectionat/a automat catre incarcarea din nou a bonului
                      fiscal/facturii. Te rugam sa realizezi o fotografie noua a bonului fiscal/facturii si s-o incarci din nou in
                      termen de 72 de ore. Butonul nu mai este functional dupa 72 de ore.
                      Daca participarea ta este respinsa din nou, te rugam sa ne contactezi prin intermediul adresei de
                      e-mail de suport, care poate fi gasita si in e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>).`
                    },
                    { // 17
                      title: 'Bonul meu fiscal/factura nu a fost acceptat/a sau chiar a fost marcat/a ca fals/a. Cum este posibil asa ceva?',
                      text: `In cazul in care bonul fiscal/factura este prea neclar/a sau prea intunecat/a sau supraexpus/a
                      astfel incat informatiile nu mai pot fi lizibile, exista posibilitatea sa primesti un e-mail de respingere, in
                      care bonul fiscal/factura este descris/a drept un fals sau esti rugat/a sa furnizezi o fotografie mai
                      buna cu <b>Incarca bonul tau fiscal/factura</b>. Ajuta-ne sa iti acceptam participarea rapid si fara
                      complicatii, incarcand o fotografie de buna calitate (nu o scanare!) a bonului tau fiscal/facturii,
                      care demonstreaza ca ai un bon fiscal/o factura original/a si in care sunt lizibile toate informatiile
                      necesare. Economiseste mult timp si neplaceri atat pentru tine, cat si pentru noi.`
                    },
                    { // 18
                      title: 'Pot trimite bonul fiscal/factura si prin e-mail?',
                      text: `Ne pare rau sa te informam ca nu este posibil sa sari peste procesul de inscriere la campanie si sa
                      ne trimiti bonul fiscal/factura prin e-mail. Echipa noastra de suport te poate ajuta doar in cazul in
                      care poti furniza numarul tau de referinta, care poate fi gasit in e-mailul de confirmare sau
                      respingere. In cazul in care nu ai primit un asemenea e-mail, trebuie sa repeti din nou procesul de
                      inregistrare.`
                    },
                    { // 19
                      title: 'Ce se intampla cu informatiile pe care le-am introdus pe site-ul promotiei?',
                      text: `Datele tale personale sunt prelucrate in scopul organizarii si desfasurarii Campaniei, pentru a-ti
                      putea permite participarea la aceasta si, in cazul in care ai fost declarat/a castigator/e, pentru a-ti
                      acorda premiul. Prelucrarea este necesara pentru executarea contractului la care esti parte, si
                      anume regulamentul Campaniei, cu care esti de acord in momentul inscrierii.`
                    },
                    { // 20
                      title: 'Am o intrebare generala despre Colgate-Palmolive. Pe cine pot contacta?',
                      text: `Daca ai nevoie de informatii suplimentare privitoare la produsele noastre sau daca ai orice alte
                      intrebari, ne poti contacta prin intermediul linkului de mai jos: <b><a href="https://www.colgatepalmolive.ro/contact-us" target="_blank">https://www.colgatepalmolive.ro/contact-us</a>.</b>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "SpringCleaningCarrefour2022/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#000000",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    {
                      title: `Castigatori Aspirator vertical si mop 3 in 1`,
                      text: `
                      <ul>
                        <li>Rosioru Marilena</li>
                        <li>Scurtu Ana</li>
                        <li>Dumitrache Ion</li>
                      </ul>`
                    },
                    {
                      title: `Castigatori Card Cadou Carrefour in valoare de 200 de lei`,
                      text: `
                      <ul>
                        <li>Mușat Mihaela</li>
                        <li>Onea Aurelia</li>
                        <li>Simion Constantin</li>
                        <li>Tanase Madalin</li>
                        <li>Gabor Drosida</li>
                        <li>Ciucioi Elena</li>
                        <li>Olaru Mircea</li>
                        <li>Ene Florin Laurentiu</li>
                        <li>Gavrila Catalin</li>
                        <li>Mihalache Simona</li>
                        <li>Bartlett Dana</li>
                        <li>Hagiu Florentina</li>
                        <li>Masculic Tamas</li>
                        <li>Dobrescu Ana</li>
                        <li>Ceaus Octavian</li>
                        <li>Halau Carmen</li>
                        <li>Micu Armand Andrei</li>
                        <li>Braga Victor</li>
                        <li>Roth Otilia</li>
                        <li>Gavriloe Ana</li>
                        <li>Rebenciuc Greta</li>
                        <li>Vadanoiu Dobrin</li>
                        <li>Adriana Scîntei</li>
                        <li>Mihaela Laura	Pirvulescu</li>
                        <li>Peia Ionica Gherghina</li>
                        <li>Stoian Robert-Ionut</li>
                        <li>Neacsu Adrian</li>
                        <li>Gheorghe Calin</li>
                        <li>Maciuceanu Mihaela</li>
                        <li>Galav Edward</li>
                        <li>Neculcea Mariana</li>
                        <li>Popescu Gabriel</li>
                        <li>Elena Stoica</li>
                        <li>Popescu Luminita</li>
                        <li>Nicoleta Mihai</li>
                        <li>Goran Maria Nicoleta</li>
                        <li>Filip Eliza</li>
                        <li>Cimpan Claudia</li>
                        <li>Kolosvari Niculina</li>
                        <li>Sandu Pirosca</li>
                      </ul>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          {
            "fieldId": "bsdb35",
            "fieldType": "anchor",
            "properties": {
              "text": "Castigatori",
              "url": "/SpringCleaningCarrefour2022/castigatori",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/SpringCleaningCarrefour2022Regulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/SpringCleaningCarrefour2022/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        },
        "fields": [
          {
            "fieldId": "ikz8vc1",
            "fieldType": "anchor",
            "properties": {
              "text": "Termeni si conditii",
              "url": "/files/SpringCleaningCarrefour2022Regulament.pdf",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          },
          {
            "fieldId": "slnmdk2",
            "fieldType": "anchor",
            "properties": {
              "text": " Politica de confidentialitate",
              "url": "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          }
        ]
      }
    },
    "campaignId": "spring-carrefour",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "SpringCleaningCarrefour2022"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'spring-carrefour',
  formData: new FormData(),
  campaignStartDate: "2022-03-24",
  campaignEndDate: "2022-04-24",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
